import {
  REQUEST_SIGNUP_OTP,
  REQUEST_SIGNUP_OTP_SUCCESS,
  REQUEST_SIGNUP_OTP_FAILED,
  VERIFY_SIGNUP_OTP,
  VERIFY_SIGNUP_OTP_SUCCESS,
  VERIFY_SIGNUP_OTP_FAILED,
  CLEAR_SIGNUP_OTP_STATE,
} from "../store/types";

import store from "../store/store";
import { firebase } from "../config/configureFirebase";

/**
 * Request OTP for signup verification
 * @param {object} userData - User registration data
 * @param {string} deliveryMethod - 'email' or 'sms'
 */
export const requestSignupOtp = (userData, deliveryMethod) => async (dispatch) => {
  const { config } = firebase;

  dispatch({
    type: REQUEST_SIGNUP_OTP,
    payload: { loading: true },
  });

  const settings = store.getState().settingsdata.settings;
  let host =
    window &&
    window.location &&
    settings.CompanyWebsite === window.location.origin
      ? window.location.origin
      : `https://${config.projectId}.web.app`;

  let url = `${host}/request_signup_otp`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: userData.email,
        mobile: userData.mobile,
        deliveryMethod: deliveryMethod,
        userData: userData,
      }),
    });

    const result = await response.json();

    if (result.success) {
      dispatch({
        type: REQUEST_SIGNUP_OTP_SUCCESS,
        payload: {
          deliveryMethod: deliveryMethod,
          message: result.message,
        },
      });
      return { success: true, method: result.method };
    } else {
      dispatch({
        type: REQUEST_SIGNUP_OTP_FAILED,
        payload: result.error || "Failed to send OTP",
      });
      return { success: false, error: result.error };
    }
  } catch (error) {
    console.error("Request signup OTP error:", error);
    dispatch({
      type: REQUEST_SIGNUP_OTP_FAILED,
      payload: error.message || "Network error",
    });
    return { success: false, error: error.message };
  }
};

/**
 * Verify OTP and complete signup
 * @param {string} email - User email
 * @param {string} mobile - User mobile
 * @param {string} otp - OTP code entered by user
 * @param {string} deliveryMethod - 'email' or 'sms'
 */
export const verifySignupOtp = (email, mobile, otp, deliveryMethod) => async (dispatch) => {
  const { auth, config } = firebase;

  dispatch({
    type: VERIFY_SIGNUP_OTP,
    payload: { loading: true },
  });

  const settings = store.getState().settingsdata.settings;
  let host =
    window &&
    window.location &&
    settings.CompanyWebsite === window.location.origin
      ? window.location.origin
      : `https://${config.projectId}.web.app`;

  let url = `${host}/verify_signup_otp`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        mobile: mobile,
        otp: otp,
        deliveryMethod: deliveryMethod,
      }),
    });

    const result = await response.json();

    if (result.success) {
      dispatch({
        type: VERIFY_SIGNUP_OTP_SUCCESS,
        payload: {
          user: result.user,
          uid: result.uid,
          message: result.message,
        },
      });

      return {
        success: true,
        uid: result.uid,
        user: result.user,
        syntheticEmail: result.syntheticEmail,
      };
    } else {
      dispatch({
        type: VERIFY_SIGNUP_OTP_FAILED,
        payload: result.error || "Verification failed",
      });
      return { success: false, error: result.error };
    }
  } catch (error) {
    console.error("Verify signup OTP error:", error);
    dispatch({
      type: VERIFY_SIGNUP_OTP_FAILED,
      payload: error.message || "Network error",
    });
    return { success: false, error: error.message };
  }
};

/**
 * Clear signup OTP state
 */
export const clearSignupOtpState = () => (dispatch) => {
  dispatch({
    type: CLEAR_SIGNUP_OTP_STATE,
  });
};
